import { CustomInput } from "./CustomInput";
import { SearchIcon } from "../images/SearchIcon";
import { Box } from "@mui/material";
import { useStateWithSearchParams, useDebounceValue } from "../../hooks";
import { useEffect, useRef, useState } from "react";

type SearchParams = {
  search?: string;
};

type Props = {
  maxWidth?: string;
  isDisabled?: boolean;
  placeholder?: string;
};

export const InputWithQuery = ({
  maxWidth,
  isDisabled,
  placeholder = "Search",
}: Props) => {
  const [value, setValue] = useState<string>("");
  const isFirstRender = useRef(true);

  const debounceValue = useDebounceValue(value);
  const { searchDict, setSearchValue } = useStateWithSearchParams<SearchParams>(
    {
      search: undefined,
    },
  );

  useEffect(() => {
    if (searchDict.search !== debounceValue) {
      setValue(searchDict.search || "");
    }
  }, [searchDict.search]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      if (searchDict.search !== debounceValue) {
        setSearchValue("search", debounceValue || undefined);
      }
    }
  }, [debounceValue]);

  return (
    <Box sx={{ maxWidth: maxWidth ? maxWidth : "284px", width: "100%" }}>
      <CustomInput
        isDisabled={isDisabled}
        value={value}
        placeholder={placeholder}
        prefixIcon={<SearchIcon />}
        onChange={setValue}
        clearButton
      />
    </Box>
  );
};
